import clsx from "clsx";
import { twMerge } from "tailwind-merge";
import { HTMLAttributes, forwardRef } from "react";

export type AlertVariant =
  | "primary"
  | "secondary"
  | "success"
  | "danger"
  | "warning"
  | "info"
  | "dark"
  | "light";

export interface AlertProps extends HTMLAttributes<HTMLDivElement> {
  variant?: AlertVariant;
}

const Alert = forwardRef<HTMLDivElement, AlertProps>((props, ref) => {
  const { className, variant = "primary", ...rest } = props;

  return (
    <div
      {...rest}
      ref={ref}
      className={twMerge(
        clsx("mb-4 rounded-sm", {
          "bg-primary text-white": variant === "primary",
          "bg-primary-light text-primary-dark": variant === "secondary",
          "bg-gunmetal-50 text-gunmetal-900": variant === "light",
          "bg-gunmetal-700 text-white": variant === "dark",
          "bg-red-500 text-white": variant === "danger",
          "bg-yellow-500 text-gunmetal-900": variant === "warning",
          "bg-sky-200 text-gunmetal-900": variant === "info",
        }),
        className
      )}
    />
  );
});

export default Alert;
